/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React, {useContext, useEffect, useRef, useState} from "react";

import useTypedSelector from "@Services/Hooks/UseTypedSelector";

import APPLICATION_ROUTER_INTERFACE from "@ROUTER/Interfaces/Router";
import ApplicationRouterContext from "@Contexts/Router";

import ApplicationApiContext from "@Contexts/Api";


import {Redirect} from "react-router-dom";


import {ERROR_SYSTEM_MESSAGE_INTERFACE} from "@Services/Application/Interfaces/_Messages/Errors";


import {Col, Form, Row} from "react-bootstrap";


import BlockContentHeaderComponent from "@Components/UI/Containers/Block/Header";
import BlockContentContainerComponent from "@Components/UI/Containers/Block";


import ErrorMessageComponent from "@Components/UI/Communicates/Messages/Error";


import dateFormat from "dateformat";

import REST_API_REQUEST from "@Services/Utilities/Requests";

import scrollToDomElement from "@Utilities/Animations/Scrolling";


import SettingsSMSCodeVerificationComponent from "@UIPages/Authenticated/Settings/_Parts/Verification";

import MyFinishedTransportsListComponent from "@UIPages/Authenticated/Settings/User/MyFinishedTransports/TransportsList";


import LOGGED_USER_INTERFACE from "@Store/Interfaces/Authentication/User";

import HTTP_ERROR_RESPONSE_INTERFACE from "@Services/Interfaces/Http/Response/Error";
import AUTHORIZATION_TOKEN_INTERFACE from "@Reducers/Api/RequestToken";

import TRANSPORT_INTERFACE from "@Services/Application/Interfaces/Transports/Transport";


type MyFinishedTransportsPageProps = {};


export const SettingsMyFinishedTransportsPageComponent: React.FC<MyFinishedTransportsPageProps> = (): JSX.Element | null => {


    /** @const {React.Ref} My Favourite Terminals Page Container DOM Ref */
    const COMPONENT_REF: React.Ref<HTMLDivElement | null> = useRef(null);


    /** @const {UserInterface | null} Application Logged User (from Global Store Object) */
    const LOGGED_USER: LOGGED_USER_INTERFACE = useTypedSelector(
        (state): ReturnType<any> => state?.authentication
    )?.loggedUser || null;


    /** @const {string} Global Rest Api Root URL Address */
    const REST_API_URL = useContext(ApplicationApiContext)?.API_ROOT_URL || null;

    /** @const {object} REST_API_DATA - Application State Store Rest Api Data */
    const REST_API_DATA:ReturnType<any> = useTypedSelector(
        (state) => state.api
    );

    /** @const {} REST_API_REQUEST_TOKEN - Application Rest Api Request Token */
    const REST_API_REQUEST_TOKEN: AUTHORIZATION_TOKEN_INTERFACE = REST_API_DATA?.requestToken || null;


    const ROUTER: APPLICATION_ROUTER_INTERFACE = useContext(ApplicationRouterContext);


    const [USER_AUTHENTICATED_STATUS, SET_USER_AUTHENTICATED_STATUS] = useState<boolean>(false);

    const CHANGE_USER_AUTHENTICATED_STATUS = (response: any) => {
        if (response.OperationGUID) SET_USER_AUTHENTICATED_STATUS(true);
    }

    const [DATE_FROM_FILTER, SET_DATE_FROM_FILTER] = useState<string>(dateFormat(new Date(), "yyyy-mm-dd"));
    const [DATE_TO_FILTER, SET_DATE_TO_FILTER] = useState<string>(dateFormat(new Date(), "yyyy-mm-dd"));

    const CHANGE_DATE_FROM_FILTER = (e: React.ChangeEvent<HTMLSelectElement>): void => {
        const NEW_DATE_FROM = e.target.value;
        SET_DATE_FROM_FILTER(NEW_DATE_FROM);
    };
    const CHANGE_DATE_TO_FILTER = (e: React.ChangeEvent<HTMLSelectElement>): void => {
        const NEW_DATE_TO = e.target.value;
        SET_DATE_TO_FILTER(NEW_DATE_TO);
    };

    const [USER_FINISHED_TRANSPORTS, SET_USER_FINISHED_TRANSPORTS] = useState<TRANSPORT_INTERFACE[] | null>(null);
    const [USER_FINISHED_TRANSPORTS_ERROR, SET_USER_FINISHED_TRANSPORTS_ERROR] = useState<ERROR_SYSTEM_MESSAGE_INTERFACE | null>(null);

    useEffect(() => {

        if (!LOGGED_USER?.userID || !REST_API_URL) return;

        const USER_FINISHED_TRANSPORTS_API_URL = `${REST_API_URL}/Transport/List`;

        const USER_FINISHED_TRANSPORTS_REQUEST_DATA = {
            UserId: LOGGED_USER?.userID,
            DateFrom: DATE_FROM_FILTER,
            DateTo: DATE_TO_FILTER
        };

        const GET_USER_FINISHED_TRANSPORTS = async (): Promise<void> => {

            try {

                const USER_DATA_RESPONSE = await REST_API_REQUEST(
                    USER_FINISHED_TRANSPORTS_API_URL,
                    USER_FINISHED_TRANSPORTS_REQUEST_DATA,
                    REST_API_REQUEST_TOKEN
                );

                if (USER_DATA_RESPONSE.status === 200) {
                    const RESPONSE_TEXT: any = await USER_DATA_RESPONSE.text();
                    if (RESPONSE_TEXT.trim()) {
                        const RESPONSE_CONTENT: TRANSPORT_INTERFACE[] = JSON.parse(RESPONSE_TEXT).Transports;
                        SET_USER_FINISHED_TRANSPORTS(RESPONSE_CONTENT);
                    } else {
                        SET_USER_FINISHED_TRANSPORTS([]);
                    }
                } else {
                    const RESPONSE_CONTENT: HTTP_ERROR_RESPONSE_INTERFACE = await USER_DATA_RESPONSE.json();
                    SET_USER_FINISHED_TRANSPORTS_ERROR({ErrorCode: USER_DATA_RESPONSE.status, UserMessage: RESPONSE_CONTENT.UserMessage})
                }

            } catch (e) {
                console.log(e);
                SET_USER_FINISHED_TRANSPORTS_ERROR({ErrorCode: 500, UserMessage: "Wystąpił nieokreślony błąd - skontaktuj się z CDOK"});
            }

        };

        GET_USER_FINISHED_TRANSPORTS();

    }, [DATE_FROM_FILTER, DATE_TO_FILTER]);


    useEffect(() => {
        if (COMPONENT_REF.current) {
            scrollToDomElement(COMPONENT_REF.current);
        }
        return () => {
            SET_USER_FINISHED_TRANSPORTS(null);
            SET_USER_FINISHED_TRANSPORTS_ERROR(null);
        };
    }, []);


    if (!LOGGED_USER || !LOGGED_USER?.userID) return <Redirect to={ROUTER.NOT_AUTHENTICATED.LOGIN.URL} />;


    if (!ROUTER) return <Redirect to={"/404"}/>;


    if (!USER_AUTHENTICATED_STATUS) return <SettingsSMSCodeVerificationComponent verificationStatusHandler={CHANGE_USER_AUTHENTICATED_STATUS} />;


    return (
        <BlockContentContainerComponent forwardRef={COMPONENT_REF} cssClasses={"settings-page-finished-transport-component finished-transport-component finished-transport-page settings-page-view-component"}>

            <BlockContentHeaderComponent headerText={"Moje zakończone Transporty"} />

            {!!USER_FINISHED_TRANSPORTS_ERROR && <ErrorMessageComponent messageText={USER_FINISHED_TRANSPORTS_ERROR.UserMessage} />}

            <Col xs={12} className={"finished-transport-filters finished-transport-filters-component"}>
                <Row className={"finished-transport-date-filters"}>
                    <Col xs={6} className={"finished-transport-date-filter date-from-filter"}>
                        <Form.Label>{`Data od`}</Form.Label>
                        <Form.Control disabled={!!USER_FINISHED_TRANSPORTS_ERROR} type={"date"} value={DATE_FROM_FILTER} onChange={CHANGE_DATE_FROM_FILTER} max={DATE_TO_FILTER} />
                    </Col>
                    <Col xs={6} className={"finished-transport-date-filter date-to-filter"}>
                        <Form.Label>{`Data do`}</Form.Label>
                        <Form.Control disabled={!!USER_FINISHED_TRANSPORTS_ERROR} type={"date"} value={DATE_TO_FILTER} onChange={CHANGE_DATE_TO_FILTER} max={dateFormat(new Date(), "yyyy-mm-dd")} />
                    </Col>
                </Row>
            </Col>

            <MyFinishedTransportsListComponent TRANSPORTS_LIST={USER_FINISHED_TRANSPORTS} />

        </BlockContentContainerComponent>
    );

}


export default SettingsMyFinishedTransportsPageComponent;
